"use client";
import store from "@/redux/store";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Provider } from "react-redux";
import { memo } from "react";
import MainLayout from "@/components-shared/main-layout";
import { CookieConsentProvider } from "@/components-shared/analytics/CookieConsentContext";
import ErrorBoundary from "./ErrorBoundary";

const queryClient = new QueryClient();

const Providers = memo(({ children }: { children: React.ReactNode }) => {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <CookieConsentProvider>
            <MainLayout>{children}</MainLayout>
          </CookieConsentProvider>
        </Provider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
});

Providers.displayName = "Providers";

export default Providers;
